export function getRedirectPathByRole(roles = []) {
    if (roles.includes('superadmin') || roles.includes('admin') || roles.includes('manager')) {
        return '/admins/dashboard';
    }

    if (roles.includes('customer')) {
        return '/customers/dashboard';
    }

    if (roles.includes('employee')) {
        return '/employees/dashboard';
    }

    return '/unauthorized';
}
